












































































































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'
import { formatJson, resetObjValue2NoneString, stringToDate } from '@/utils/tool'
import { getNoticeList, deleteNotice, getNoticeDetail, modifyNotice, noticeSwitch } from '@/api/content/content-notice/notice'
import Sortable from 'sortablejs'
import { exportJson2Excel } from '@/utils/excel'

const classifyList = [
  {
    id: '1',
    name: '热门'
  },
  {
    id: '2',
    name: '流行'
  }
]

const tableData = [
  {
    id: 1,
    title: '重要通知',
    content: '哈哈哈哈哈哈哈啊哈',
    language: 'Zh',
    type: '官网',
    status: '是',
    link: 'http://xxx.com',
    displayDateStart: '2019/08/25 14:54:00',
    displayDateEnd: '2020/08/25 14:54:00',
    updateDate: '2019/08/25 14:54',
    editor: 'huhua'
  },
  {
    id: 2,
    title: '重要通知',
    content: '哈哈哈哈哈哈哈啊哈',
    language: 'Zh',
    type: '官网',
    status: '是',
    link: 'http://xxx.com',
    displayDateStart: '2019/08/25 14:54:00',
    displayDateEnd: '2020/08/25 14:54:00',
    updateDate: '2019/08/25 14:54',
    editor: 'huhua'
  }
]
@Component({
  name: 'NotifyList'
})
export default class extends mixins(DateOption) {
  params = {
    id: '',
    title: '',
    content: '',
    type: '',
    language: '',
    status: '',
    editor: '',
    displayDateStart: '',
    displayDateEnd: '',
    updateDateStart: '',
    updateDateEnd: '',
    page: 1,
    pageCount: 20
  }
  tableLoading = false
  tableData: any[] = []
  selectedData: any[] = []
  classifyList = classifyList
  dateArray: string[] = ['', '']
  updateDateArray: string[] = ['', '']
  notifyArray: string[] = ['', '']
  totalCount = 0
  routeQuery: IQuery = { id: 0, platform: 'ios' }
  typeMap: string[] = ['全局', 'PC端', '移动端', 'iOS', '安卓官网']
  addFormVisible: boolean = false
  addParams: any = {
    id: 0,
    title: '',
    language: '',
    type: '',
    status: '',
    link: '',
    displayDateStart: '',
    displayDateEnd: '',
    content: ''
  }
  tableHeight: number = 500
  openWindow: any

  created() {
    this.getTableData()
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
  }

  mounted() {
    this.rowDrop()
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.setTableHeight)
  }

  setTableHeight() {
    const filter: any = this.$refs.filter
    const filterDom: any = filter.$el
    this.tableHeight = document.body.clientHeight - 250 - filterDom.clientHeight
  }

  async getTableData() {
    this.tableLoading = true
    // this.tableData = tableData
    const res: any = await getNoticeList(this.params)
    const { dataList, pageInfo } = res.data
    this.totalCount = pageInfo.totalCount
    this.tableData = dataList
    this.tableLoading = false
  }

  rowDrop() {
    const table = document.querySelector('.el-table__body-wrapper tbody')
    const _this = this
    // table 有值时才能对其进行操作
    if (table) {
      Sortable.create(table, {
        handle: '.bars',
        onEnd({ oldIndex, newIndex }: any) {
          if (oldIndex !== newIndex) {
            console.log(oldIndex, newIndex)
          }
        }
      })
    }
  }

  handleDateChange(date: string[] | any) {
    this.params.displayDateStart = date && date[0]
    this.params.displayDateEnd = date && date[1]
  }
  onChange(val: any) {
    if (val && val.length) {
      this.addParams.displayDateStart = stringToDate(val[0])
      this.addParams.displayDateEnd = stringToDate(val[1])
    }
  }
  handleUpdateDateChange(date: string[] | any) {
    this.params.updateDateStart = date && date[0]
    this.params.updateDateEnd = date && date[1]
  }
  handleSearch() {
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    resetObjValue2NoneString(this.params, ['page', 'pageCount'])
    this.params.page = 1
    this.dateArray = ['', '']
    this.getTableData()
  }
  handleSwitch(id: number) {
    noticeSwitch({ id }).then(() => {
      this.$message.success('操作成功')
    })
    console.log(id)
  }
  handleAdd() {
    this.handleEdit({ id: 0 })
    // this.openWindow({
    //   name: 'NoticeEdit',
    //   query: this.routeQuery
    // })
  }
  async getDetail(id: number) {
    const res: any = await getNoticeDetail({ id })
    const d: any = res.data
    this.addParams = d
    this.notifyArray = [d.displayDateStart, d.displayDateEnd]
  }
  resetAddParams() {
    this.addParams = {
      id: 0,
      title: '',
      language: '',
      type: '',
      status: '',
      link: '',
      displayDateStart: '',
      displayDateEnd: '',
      content: ''
    }
  }
  handleEdit({ id }: any) {
    if (id) {
      this.getDetail(id)
    } else {
      this.notifyArray = ['', '']
      this.resetAddParams()
    }
    this.addFormVisible = true
    // this.routeQuery.id = item.id
    // this.routeQuery.platform = item.platform.toLowerCase()
    // this.routeQuery.platform = 'ios'
    // this.openWindow({
    //   name: 'NoticeEdit',
    //   query: this.routeQuery
    // })
  }

  cancelAddForm() {
    this.addFormVisible = false
  }
  checkParams() {
    const p: any = { ...this.addParams }
    const checkList = ['type', 'title', 'content', 'language', 'displayDateStart', 'displayDateEnd']
    const warnList = ['通告类型', '标题', '内容', '语言', '开始时间', '结束时间']
    p.type = p.type.toString()
    p.status = p.status.toString()
    for (const i in checkList) {
      if (!p[checkList[i]]) return this.$message.warning('请设置' + warnList[i])
    }
    return false
  }
  async confirmAddForm() {
    const pass = this.checkParams()
    if (pass) return false
    const res: any = await modifyNotice(this.addParams)
    if (~~res.status.code === 0) {
      this['$message'].success('操作成功')
      this.cancelAddForm()
      this.getTableData()
    }
  }

  handleSelectionChange(list: any[]) {
    this.selectedData = list
  }
  handleSelectAll() {
    // 如果没有选择全部, 则寻找未选择的行, 并将这些行选中
    if (this.selectedData.length < this.tableData.length) {
      let tempSelectList = this.selectedData.map(item => item.id)
      let unSelected: any[] = this.tableData.filter((item: any) => !tempSelectList.includes(item.id))
      unSelected.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleSelectReverse() {
    this.selectedData = []
    let tempList: number[] = []
    let tempSelectList: number[] = []
    let indexList: number[] = []
    tempList = this.tableData.map(item => item.id)
    tempSelectList = this.selectedData.map(item => item.id)
    indexList = tempList.filter(item => !tempSelectList.includes(item))
    this.tableData.forEach(item => {
      if (indexList.includes(item.id)) this.selectedData.push(item)
    })
    if (this.selectedData.length) {
      this.selectedData.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleDeleteAll() {
    // this.setAccount(type, this.selectIds)
  }
  handleExcel() {
    // let res: any = await getIosList({
    //   page: 1,
    //   pageCount: 3000
    // })
    // if (res.status.code === 0) {
    //   this['$message'].success('导出成功')
    // } else {
    //   this['$message'].error('导出失败')
    //   return
    // }
    const filterVal: string[] = [
      'id',
      'name',
      'developer',
      'category',
      'source',
      'version',
      'price',
      'socre',
      'status',
      'editor',
      'updateDate'
    ]
    const theader: string[] = [
      'ID',
      '名称',
      '开发者',
      '类别',
      '来源',
      '版本',
      '价格',
      '评分',
      '应用状态',
      '编辑人',
      '最后修改时间'
    ]
    if (this.selectedData.length <= 0) {
      return this.$message.warning('请选择数据')
    }
    const list = this.selectedData
    const data = formatJson(filterVal, list)
    exportJson2Excel(theader, data)
    this['$message'].success('导出成功!')
    ;(this.$refs['multiTable'] as any).clearSelection()
  }

  // computed
  get showMultiSelect() {
    return this.selectedData.length > 1
  }
  get selectCount() {
    return this.selectedData.length
  }
  get selectIds() {
    let t: number[] = []
    this.selectedData.forEach(item => {
      t.push(item.id)
    })
    let ids = t.join(',')
    return ids
  }

  handleDelete(item: any) {
    this.$confirm('确认删除该数据?', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        let res: any = await deleteNotice({
          ids: item.id
        })
        if (res.status.code === 0) {
          this['$message'].success('删除成功')
          this.getTableData()
        } else {
          this['$message'].error('删除失败')
        }
      })
      .catch(() => {})
  }
}
